import { equals, isEmpty } from '@qld-recreational/ramda';

const trimTrailingSlashes = (path: string) => path.replace(/\/+$/, '');

const normalizePath = (path: string) => trimTrailingSlashes(path || '/');

const parseUrl = (url: string): URL | null => {
  try {
    return new URL(url);
  } catch {
    return null;
  }
};

const isSameOrigin = (requestUrl: URL, trustedBaseUrl: URL) =>
  equals(requestUrl.protocol, trustedBaseUrl.protocol) &&
  equals(requestUrl.hostname, trustedBaseUrl.hostname) &&
  equals(requestUrl.port, trustedBaseUrl.port);

const isSameOrChildPath = (requestPath: string, trustedBasePath: string) =>
  equals(requestPath, trustedBasePath) ||
  isEmpty(trustedBasePath) ||
  requestPath.startsWith(`${trustedBasePath}/`);

export const isTrustedApiUrl = (
  requestUrl: string,
  trustedBaseUrls: Array<string | null | undefined>,
): boolean => {
  const parsedRequestUrl = parseUrl(requestUrl);

  if (!parsedRequestUrl) {
    return false;
  }

  return trustedBaseUrls.some((trustedBaseUrl) => {
    if (!trustedBaseUrl) {
      return false;
    }

    const parsedTrustedBaseUrl = parseUrl(trustedBaseUrl);

    if (!parsedTrustedBaseUrl) {
      return false;
    }

    return (
      isSameOrigin(parsedRequestUrl, parsedTrustedBaseUrl) &&
      isSameOrChildPath(
        normalizePath(parsedRequestUrl.pathname),
        normalizePath(parsedTrustedBaseUrl.pathname),
      )
    );
  });
};
